<odq-navigation-step [showPreviousStep]="showPreviousStep"
                     [showNextStep]="showNextStep"
                     [disableButtons]="disableButtons"
                     (onPreviousStep)="previousStep()"
                     (onNextStep)="nextStep()">
    <odq-section-header [title]="title | translate"></odq-section-header>
</odq-navigation-step>
<odq-section-separator></odq-section-separator>

<ng-content></ng-content>

<odq-section-separator></odq-section-separator>
<odq-navigation-step [showPreviousStep]="showPreviousStep"
                     [showNextStep]="showNextStep"
                     [disableButtons]="disableButtons"
                     (onPreviousStep)="previousStep()"
                     (onNextStep)="nextStep()">
</odq-navigation-step>